<svg class="line" viewBox="0 0 10 2" preserveAspectRatio="none">
  <line x1="0" y1="0" x2="10" y2="0" style=""
        vector-effect="non-scaling-stroke" class="linecolor"/>
</svg>